export function headerFunc() {
  // ハンバーガーメニュー実装
  $('.navToggle').on('click', function () {
    $('.navToggle').toggleClass('closeNav');
    $('.headerNav').toggleClass('openNav');
  });
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 40) {
      $('#header').addClass('scr');
    } else {
      $('#header').removeClass('scr');
    }
  });
}

export function headerScrFunc() {
  //console.log('スクロールで呼ばれます。');
}